module.exports = __webpack_public_path__ + "img/GAME_MULTI JANGGI1.5e28f7ff.jpg";